import { memo } from 'react';

import {
  DATE_FORMAT_LONG_MINUTE_FNS,
  SYSTEM_DATE_FORMAT_SHORT_FNS,
} from 'CorePackage/MainModule/constants/dateFormats';
import { IKnmPreview } from 'APIPackage/KnmSearchModule/interfaces/IKnmPreview';
import { formatDateLocale } from 'CorePackage/MainModule/common/formatDate';

import styles from './KnmPreview.module.scss';
import { convertArrayToDate } from '../common/convertArrayToDate';
import { KnmChangeWarning } from './KnmChangeWarning';

interface IKnmFaceProps {
  passportData: IKnmPreview;
}

export const KnmFace = memo(({ passportData }: IKnmFaceProps) => (
  <div className={styles.ColumnContent}>
    <KnmChangeWarning
      date={passportData?.dateReasonChangeControllingSubject}
      oldNameControllingSubject={passportData?.oldNameControllingSubject}
      type={'SUBJECT_OBJECT'}
    />
    <span className={styles.SectionTitle}>Субъект КНМ</span>
    {passportData.subject && typeof passportData.subject.resident === 'boolean' && (
      <div className={styles.Row}>
        <div className={styles.ColText}>Субъект проверки - Резидент РФ</div>
        <div className={styles.ColValue}>{passportData.subject.resident ? 'Есть' : 'Нет'}</div>
      </div>
    )}
    {passportData.subject?.typeName && (
      <div className={styles.Row}>
        <div className={styles.ColText}>Тип субъекта КНМ</div>
        <div className={styles.ColValue}>{passportData.subject.typeName}</div>
      </div>
    )}
    {passportData.subject && (
      <div className={styles.Row}>
        <div className={styles.ColText}>
          Наименование юридического лица (ЮЛ) или фамилия, имя, отчество (последнее – при наличии) индивидуального
          предпринимателя, в отношении которого проводится КНМ
        </div>
        <div className={styles.ColValue}>{passportData.subject.orgName}</div>
      </div>
    )}
    {passportData.subject && (
      <div className={styles.Row}>
        <div className={styles.ColText}>ИНН проверяемого лица</div>
        <div className={styles.ColValue}>{passportData.subject.inn}</div>
      </div>
    )}
    {passportData.subject && (
      <div className={styles.Row}>
        <div className={styles.ColText}>ОГРН проверяемого лица</div>
        <div className={styles.ColValue}>{passportData.subject.ogrn}</div>
      </div>
    )}
    {passportData.subject && passportData.subject.registrationDate && (
      <div className={styles.Row}>
        <div className={styles.ColText}>
          Дата присвоения ОГРН (дата регистрации) юридического лица (ЮЛ) или индивидуального предпринимателя (ИП)
        </div>
        <div className={styles.ColValue}>
          {formatDateLocale({
            date: convertArrayToDate(passportData.subject.registrationDate),
            dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
            parseFormat: SYSTEM_DATE_FORMAT_SHORT_FNS,
          })}
        </div>
      </div>
    )}
  </div>
));
